<template>
  <span v-if="severity == '1' || severity == '2' || severity == '3'">
    <h3>
      This is a
      <span v-if="severity == '1'" class="badge bg-danger">Severity 1</span>
      <span v-if="severity == '2'" class="badge bg-warning">Severity 2</span>
      <span v-if="severity == '3'" class="badge bg-primary">Severity 3</span>
      <span v-if="severity == '4'" class="badge bg-primary">Severity 4</span>
      incident
    </h3>
  </span>
</template>

<script>
export default {
  props: ['severity'],
}
</script>
